import Dialog from '@mui/material/Dialog';

import './index.less';
import useConfig from 'hooks/useConfig';

const MobileKeyFormDialog = (props: { open: boolean; handleClose: () => void }) => {
    const { open, handleClose } = props;
    const { locale } = useConfig();
    const handleCloseDialog = () => {
        handleClose();
    };

    return (
        <Dialog
            open={open}
            PaperProps={{
                sx: {
                    margin: 0,
                    padding: 0,
                    backgroundColor: 'transparent',
                    boxShadow: 'none',
                    maxWidth: '100%'
                }
            }}
            sx={{ p: 0, border: 'none', margin: 0 }}
            maxWidth={false}
            onClose={handleCloseDialog}
        >
            <section
                className={
                    locale === 'en'
                        ? 'en-mobile-promotion-dialog'
                        : locale === 'tc'
                        ? 'tc-mobile-promotion-dialog'
                        : 'mobile-promotion-dialog'
                }
            >
                <div style={{ width: '60px', height: '70px', cursor: 'pointer' }} onClick={handleCloseDialog}></div>
            </section>
        </Dialog>
    );
};
export default MobileKeyFormDialog;
